<script>
  import { TopBar, LoadingOverlay } from '@/components/_shared'
  import { channelResource } from '@/api'

  export default {
    name: 'channels-edit-view',

    components: {
      LoadingOverlay,
      TopBar
    },

    metaInfo () {
      return {
        title: this.channel ? `${this.channel.name} - Edit Channel` : 'Loading...'
      }
    },

    data () {
      return {
        loading: true,
        channel: {}
      }
    },

    methods: {
      handleSave () {
        return channelResource.update(this.channel).then(res => {
          this.channel = res.data.returnValue
        })
      },

      handleSaveAndClose (e) {
        this.handleSave(e).then(() => {
          this.$router.push('/channels')
        })
      }
    },

    created () {
      const id = this.$route.params.id

      channelResource.find(id).then(res => {
        this.channel = res.data.returnValue
        this.loading = false
      })
    }
  }
</script>

<template>
  <div>
    <top-bar :title="`Channels / ${channel.name}`" icon="play">
      <template slot="actions">
        <b-button @click="handleSave">Save Changes</b-button>
        <b-button variant="primary" @click="handleSaveAndClose">Save & Close</b-button>
      </template>
    </top-bar>
    <b-container fluid>
      <loading-overlay :is-loading="loading">
        <h1>Loaded</h1>
      </loading-overlay>
    </b-container>
  </div>
</template>
